import { combineReducers } from 'redux'

import { reducer as network } from '@nocode-works/template/store/modules/network'
import { reducer as dialog } from '@nocode-works/template/store/modules/dialog'
import { reducer as publish } from '@nocode-works/template/store/modules/publish'
import { reducer as snackbar } from '@nocode-works/template/store/modules/snackbar'
import { reducer as website } from '@nocode-works/template/store/modules/website'
import { reducer as fileupload } from '@nocode-works/template/store/modules/fileupload'
import { reducer as router } from '@nocode-works/template/store/modules/router'
import { reducer as ui } from '@nocode-works/template/store/modules/ui'
import { reducer as job } from '@nocode-works/template/store/modules/job'
import { reducer as system } from '@nocode-works/template/store/modules/system'
import { reducer as drive } from '@nocode-works/template/store/modules/drive'
import { reducer as user } from './modules/user'
import { reducer as template } from './modules/template'
import { reducer as stripe } from './modules/stripe'
import { reducer as appsumo } from './modules/appsumo'

const reducers = {
  router,
  snackbar,
  network,
  dialog,
  publish,
  user,
  website,
  ui,
  job,
  system,
  drive,
  fileupload,
  template,
  stripe,
  appsumo,
}

export default combineReducers(reducers)
